import script from "./Header.vue?vue&type=script&lang=ts&setup=true"
export * from "./Header.vue?vue&type=script&lang=ts&setup=true"

import "./Header.vue?vue&type=style&index=0&id=13cad97e&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=13cad97e&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13cad97e"]])

export default __exports__